/**
 * DEPRECATED: Please consult with the FE Performance team before using this file.
 */
export const FILTERED_SHIFTS_LIMIT = 50;
export const FILTERED_SHIFTS_BOL_ERRORS_LIMIT = 50;
